import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, TreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const AddBtnSameLevel = (props: Props) => {
  const tree = useContext(TreeContext)

  const formData = useMemo(() => {
    return { parentFormId: tree.selectedNodes[0]?.Node?.PARENT_ID }
  }, [tree.selectedNodes[0]?.Node?.PARENT_ID])

  const formCode = tree.treeConfig.Nav_Form?.CODE
  const { LABEL, ICON, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='PlusCircleOutlined' />}
      onClose={() => tree.getTreeData()}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default AddBtnSameLevel